<template>
  <v-reports
    v-model="page"
    v-bind:headers="headers"
    v-bind:update="loadData"
    v-bind:data="data"
    show-total
    v-bind:numPages="numPages"
    :data_loading="data_loading"
    @change-pagination="changePagination"
    workgroup-order
  />
</template>

<script>

export default {
  name: "workgroup-order-report",
  data: () => ({
    data_loading: false,
    data: [],
    numPages: 1,
    page: 1,
    params: null,
  }),
  computed: {
    headers() {
      return [
        {
          text: this.$t("employee_name"),
          value: "employee_name",
          available: true
        },
        {
          text: this.$t("workgroup_name"),
          value: "workgroup_name",
          available: true
        },
        {
          text: this.$t("count"),
          value: "count",
          available: true
        },
        {
          text: this.$t("quantity"),
          value: "quantity",
          available: true
        },
        // {
        //   text: this.$t("date"),
        //   value: "date",
        //   available: true
        // }
      ];
    }
  },
  watch: {
    page() {
      if (!this.params) return;
      this.loadData(this.params);
    },
  },
  methods: {
    changePagination(page) {
      this.page = page;
    },
    async loadData(params) {
      this.params = params;
      if (!params) return;
      this.data_loading = true;
      let start_date = new Date(params.start_date).getTime();
      let end_date = new Date(params.end_date).getTime();
      const result = this.$communicator.then(
        this,
        await this.$communicator("workgroup_report_employee", {
          params: {
            start_time: start_date,
            end_time: end_date,
            limit: 10,
            page: this.page
          }
        })
      );
      if (result && result.data instanceof Array) {
        this.data = result.data;
        this.numPages = Math.ceil(result.total / 10);

        if (!this.numPages) {
          this.numPages = 1;
        }
      } else {
        this.data = [];
        this.numPages = 1;
        this.page = 1;
      }
      
      this.data_loading = false;
    }
  },
  mounted() {}
};
</script>
